import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "favourites-off",
  "use": "favourites-off-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"favourites-off\"><path d=\"M15.828 23.397s-8.5-4.773-8.5-10.568a4.44 4.44 0 0 1 1.002-2.81 4.41 4.41 0 0 1 5.496-1.102 4.427 4.427 0 0 1 2.002 2.207v0a4.428 4.428 0 0 1 2.003-2.207 4.41 4.41 0 0 1 5.495 1.102 4.44 4.44 0 0 1 1.002 2.81c0 5.795-8.5 10.568-8.5 10.568Z\" stroke=\"#9C9C9C\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol